import { Link } from "react-router-dom";

export function PricingHero() {
  return (
    <section className="bg-gradient-hero text-white py-20">
      <div className="container mx-auto px-6 text-center max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          HostCaptain Pricing
        </h1>
        <p className="text-lg text-white/90">
          HostCaptain grows with your business, from <Link to="/docs/how-to-sign-up-as-turo-host" className="underline hover:text-white">your first car</Link> to your professional fleet.
        </p>
      </div>
    </section>
  );
}
